import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { IAppError } from "config";
import { Layout, useTranslation } from "modules";

import { RootState } from "../../../store";
import { closeModal } from "../../../store/actions/modal";

type ErrorObjectType = IAppError & InstanceType<ErrorConstructor>;

const ReinstatementErrorModal: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { error = {} } = useSelector((state: RootState) => state.modal.data);
  const { code = "", fullMessage = "", message = "" } = error as ErrorObjectType;

  if (!error || Object.keys(error).length === 0) {
    return null;
  }

  const closeModalWrapper = () => {
    dispatch(closeModal());
    navigate("/account/policy-reinstatement");
  };

  const content = {
    icon: "BlobAlert",
    header: t(
      "errors.new_application.blocked",
      "Sorry, you can’t apply for new coverage right now."
    ),
    subheader: fullMessage || code || message,
    onClose: closeModalWrapper,
    button: {
      onClick: closeModalWrapper,
      text: t("ok", "OK"),
    },
  };

  return <Layout as="ModalLayout" content={content} />;
};

export default ReinstatementErrorModal;
